import React from "react";
import noop from "lodash/noop";
import { S3 } from "../../constants";
import { RillContext } from "../../rill/RillReact/share/base";

class ImageChatUploadInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modified: false,
      src: undefined,
      backgroundedit: undefined,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleReset(e) {
    if (e && e.target && e.target.hasAttribute("data-noreset")) return;
    this.setState({
      src: undefined,
      modified: false,
      backgroundedit: undefined,
    });
  }

  handleChange({ target }) {
    if (!target.value) {
      return false;
    } else {
      // extract file
      const file = target.files[0];

      // setup file reader
      const fileReader = new FileReader();

      // store the image in state once it's loaded off the file system
      fileReader.onload = (event) => {
        this.setState({
          src: event.target.result,
          modified: true,
          backgroundedit: undefined,
        });
        if (this.props.handleImageUpload) {
          this.props.handleImageUpload();
        }
      };

      // handle the error...kind of.
      fileReader.onerror = function (event) {
        console.error(
          "File could not be read! Code " + event.target.error.code
        );
      };

      // finally read the file
      fileReader.readAsDataURL(file);
    }
  }

  componentWillMount() {
    const fullImagePath = this.props.defaultValue.file
      ? `/api/file/${this.props.defaultValue.file}`
      : this.props.defaultValue;
    this.setState({
      src: fullImagePath,
      backgroundedit: S3.toCDN(this.props.backgroundedit),
    });
  }

  render() {
    const { locals } = this.context;
    const {
      name,
      raw,
      prefix,
      required = false,
      key,
      hasImage,
      isDisable = false,
    } = this.props;
    const { modified, src, backgroundedit } = this.state;
    const defaultValue = this.props.defaultValue.file;
    const imageBackground = backgroundedit
      ? backgroundedit
      : src || defaultValue;

    const divStyle = {
      cursor: isDisable ? "not-allowed" : "pointer",
    };

    const beforeStyle = {
      backgroundImage: `url(${imageBackground})`,
      backgroundSize: "cover",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
    };

    return (
      <div>
        <label>
          {!imageBackground ? (
            <div className="add-new-chat-image-div">
              <IconChat hasImage={hasImage} />
            </div>
          ) : (
            <div className={"edit-new-chat-image-div"} style={divStyle}>
              <div style={beforeStyle}></div>
              <div></div>
              <IconChat hasImage={hasImage} />
            </div>
          )}

          <input
            style={{ display: "none" }}
            key={defaultValue}
            ref="input"
            id="file-input"
            className="file-input"
            {...this.props}
            type="file"
            accept="image/*"
            required={!defaultValue && this.props.required}
            onChange={this.handleChange}
            defaultValue={undefined}
            disabled={isDisable}
          />
        </label>

        {!modified && defaultValue && (
          <input
            type="hidden"
            name={`${name}[file]`}
            value={defaultValue}
            onChange={noop}
            disabled={isDisable}
          />
        )}
      </div>
    );
  }
}

ImageChatUploadInput.defaultProps = {
  defaultValue: {},
};

ImageChatUploadInput.contextType = RillContext;

export default ImageChatUploadInput;

const IconChat = ({ hasImage }) => {
  return !hasImage ? (
    <img
      src="/img/svg/add_a_photo_white.svg"
      alt="back"
      width={24}
      height={24}
    />
  ) : (
    <img
      src="/img/new-icons/edit-pencil.svg"
      alt="back"
      width={24}
      height={24}
    />
  );
};
